<template>
   <router-view/>
</template>

<script>
export default {
   name: 'App',

};
</script>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
    box-sizing:border-box;
}
body {
    // background-image: url('./assets/a.jpg');
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
